module.exports = __webpack_public_path__ + "static/media/toolBox.c5bbfd35.svg";